import angular from 'angular';

angular.module('cloudX').directive('europeanOnly', [
  'dataCache',
  function(dataCache) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var tenantConfiguration = dataCache.getArray('tenantConfiguration');
        if (tenantConfiguration == 2) {
          element.remove();
        }
      },
    };
  },
]);
